


























import { Vue, Component } from 'vue-property-decorator';
import { List } from 'vant';
import { getVoteList } from '../api';

Vue.use(List);

@Component
export default class Intro extends Vue {
  page = 1;
  loading = false;
  finished = false;
  voteList: any[] = [];

  async created() {
    this.onGetVoteList();
  }

  async onGetVoteList() {
    this.loading = true;
    const ret = await getVoteList(this.page, '', '1');
    this.loading = false;
    if (!ret.data.length) {
      this.finished = true;
    } else {
      this.voteList = [...this.voteList, ...ret.data];
      this.page++;
    }
  }

  onNavTo(item: any, index: number) {
    this.$routerThen
      .push({
        url: `detail?id=${item.id}`,
      })
      .then((vm) => {
        vm.$on('zanUpdate', () => {
          this.voteList[index].votes = Number(this.voteList[index].votes) + 1;
        });
      });
  }
}
